/* eslint-disable react-native/no-color-literals */
import React from 'react';
import { View, StyleSheet } from 'react-native';

import RowView from './RowView';
import Icon from './Icon';
import BaseText from './BaseText';

import { CommonStyles, CommonProperties } from '../styles';

const BillingInfoLabel = ({ icon, text, fromPickerModal = false }) => {
  return (
    <View style={[styles.travelerBox, fromPickerModal ? styles.travelerBoxWidth : null]}>
      <RowView>
        <Icon name={icon} style={styles.icon} />
        <BaseText style={styles.title}>{text}</BaseText>
      </RowView>
    </View>
  );
};

const styles = StyleSheet.create({
  travelerBox: {
    backgroundColor: '#f6f6f6',
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...CommonProperties.py2,
    ...CommonProperties.px3,
    ...CommonProperties.borderRadius4,
    alignItems: 'stretch',
  },
  travelerBoxWidth: {
    width: '100%',
  },
  icon: {
    color: '#9c9e9f',
    ...CommonProperties.h3,
    ...CommonProperties.mr3,
  },
  title: {
    ...CommonStyles.body,
  },
});

export default BillingInfoLabel;
